<template><div><h1 id="botenroutierungen" tabindex="-1"><a class="header-anchor" href="#botenroutierungen"><span>Botenroutierungen</span></a></h1>
<p>Botenroutierungen — Definition der verarbeitbaren Botenroutierungs-Möglichkeiten</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Diese Tabelle definiert die im System verarbeitbaren Botenroutierungs-Möglichkeiten und wird durch ARENAE gemäss den Bedürfnissen des Kunden eingerichtet. Siehe auch <RouteLink to="/manual/administration/botenroutierung.html" title="6. Botenroutierung">Botenroutierung, Beschreibung</RouteLink>.</p>
<p>Pfad: <code v-pre>Datenaustausch → Tabellen → Postdaten → Botenroutierungen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Code</dt>
<dd>Botenroutierungscode, 3-stellig, alphanumerisch</dd>
<dt>Typ</dt>
<dd>Botenroutierungs-Bezeichnung der Post, 2-stelligPP = PPAZ = AZB</dd>
<dt>min. Sendungen/Bund</dt>
<dd>Minimale Anzahl Sendungen im Bund, 2-stellig, numerisch</dd>
<dt>max. Sendungen/Bund</dt>
<dd>Maximale Anzahl Sendungen im Bund, 2-stellig, numerisch</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung des Botenroutierungscodes</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/administration/botenroutierung.html" title="6. Botenroutierung">Botenroutierung, Beschreibung</RouteLink></p>
</div></template>


